import { render, staticRenderFns } from "./qualityImprovementListA.vue?vue&type=template&id=4a505961&scoped=true"
import script from "./qualityImprovementListA.vue?vue&type=script&lang=js"
export * from "./qualityImprovementListA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a505961",
  null
  
)

export default component.exports